module.exports = __webpack_public_path__ + "media/images/img_magazine1-217142b03afe63e8062e1a2c32c138b6.jpg";